import { unregisterExtension } from './extensions-actions';

/**
 * Remove an installed extension from disk and tear it down in the running app.
 *
 * Shared by the installed-extensions list, the local detail panel and the
 * marketplace detail panel so all three report failures honestly — the worker
 * resolves rather than rejects on error, so its status has to be checked.
 *
 * @returns {Promise<{success: boolean, message?: string}>}
 */
export async function uninstallInstalledExtension(name, dispatch){
    if(!name) return { success: false, message: 'Extension name is required' };

    let configData;
    try{
        configData = await bodapro.getConfig();
    }catch(e){
        return { success: false, message: e.message || 'Could not load BodaPro configuration.' };
    }

    if(!configData?.configFile){
        return { success: false, message: 'Could not load BodaPro configuration.' };
    }

    let result;
    try{
        result = await bodapro.uninstallExtension({
            extension: { name },
            bodaProConfigFile: configData.configFile
        });
    }catch(e){
        return { success: false, message: e.message || 'Uninstall failed' };
    }

    if(result?.status !== 'success'){
        return { success: false, message: result?.message || 'Uninstall failed' };
    }

    // Best effort: the folder is already gone, so a teardown failure should not
    // be reported as a failed uninstall. A reload cleans up whatever is left.
    try{
        await window['bodapro-context']?.executeCommand('bodapro.extensions.deactivate', { name });
    }catch(e){
        console.log('deactivate after uninstall failed:', e);
    }

    if(dispatch) dispatch(unregisterExtension(name));
    globalThis['BODAPRO_EXTENSIONS'] = (globalThis['BODAPRO_EXTENSIONS'] || []).filter(v => v !== name);

    return { success: true, message: result?.message || 'Extension uninstalled' };
}

export default uninstallInstalledExtension;
